import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const operationBenefitGroupService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/OperationBenefitGroups`, { headers });
  },

  getActive: async () => {
    return await axios.get(`${domain}/api/OperationBenefitGroups/active`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/OperationBenefitGroups`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/OperationBenefitGroups/${id}`, payload, { headers });
  }
};